import { Controller } from "@hotwired/stimulus"
import { useIntersection } from 'stimulus-use'

export default class extends Controller {
  connect() {
    useIntersection(this)
  }
  
  appear() {
    this.submit()
  }

  submit() {
    this.element.requestSubmit()
  } 
}